// extracted by mini-css-extract-plugin
export default {"containerDropdown":"ratelier_containerDropdown__qLyL3"};